//  ----------      START   IMPORT  BLOCK       ----------
import { useParams } from 'react-router-dom';
import DocsContainer from '../../General/LandingPage/DocsLayout/DocsContainer';
import { getProUserManualContent } from './ProUserManualContent';
import BaseLayout from '../../General/LandingPage/BaseLayout/BaseLayout';
//  Context
import { useLanguage } from '../../../../API/Context/LanguageContext';
//  ----------      END   IMPORT  BLOCK       ----------

function ProUserManual({  }) {
  //  Consume context
  const { lan } = useLanguage()

  const { sectionId } = useParams();
  const content = getProUserManualContent(lan)

  return (
    <BaseLayout lan={lan}>
      <DocsContainer sections={content} initialSectionId={sectionId || content[0].id} />
    </BaseLayout>
  );
}

export default ProUserManual;

